import { lazy } from 'react';
import { detectLanguage } from '../../services/helpers';
import KustomReceipt from 'components/KustomReceipt';
// import Index from '../../views/Index';
// import HowItWorks from '../../views/HowItWorks';
// import GolfCourses from '../../views/GolfCourses';
// import GolfCourse from '../../views/GolfCourse';

// import Activate from '../../views/Activate';
// import Webshop from '../../views/Webshop';
// import GolfClub from '../../views/GolfClub';
// import NewsPost from '../../views/NewsPost';

const Index = lazy(() => import('../../views/Index'));
const HowItWorks = lazy(() => import('../../views/HowItWorks/HowItWorks'));
const GolfCourses = lazy(() => import('../../views/GolfCourses'));
const CountryDistrict = lazy(() => import('../../views/CountryDistrict'));
const GolfCourse = lazy(() => import('../../views/GolfCourse'));
const Map = lazy(() => import('../../views/Map'));
const Activate = lazy(() => import('../../views/Activate'));
const ActivateDone = lazy(() => import('../../views/ActivateDone'));
const ActivateAdidas = lazy(() => import('../../views/Activate'));
const Webshop = lazy(() => import('../../views/Webshop'));
const GolfClub = lazy(() => import('../../views/GolfClub/GolfClub'));
const GolfClubCalculator = lazy(() => import('../../views/GolfClub/GolfClubCalculator'));
const NewsPost = lazy(() => import('../../views/NewsPost'));
const ActivatePlus = lazy(() => import('../../views/ActivatePlus'));
const Account = lazy(() => import('../../views/Account'));
const Login = lazy(() => import('../../views/Login'));
const About = lazy(() => import('../../views/About/About'));
const Contact = lazy(() => import('../../views/Contact/Contact'));
const Recommend = lazy(() => import('../../views/Recommend'));
const Press = lazy(() => import('../../views/Press'));
const Faq = lazy(() => import('../../views/Faq/Faq'));
const Terms = lazy(() => import('../../views/Terms'));
const Privacy = lazy(() => import('../../views/Privacy'));
const Cookies = lazy(() => import('../../views/Cookies'));
const News = lazy(() => import('../../views/News'));
const Retailers = lazy(() => import('../../views/Retailers/Retailers'));
const Survey = lazy(() => import('../../views/Survey'));
const Plus = lazy(() => import('../../views/Plus/Plus'));
const WhyBuyCard = lazy(() => import('../../views/WhyBuyCard'));
const Compete = lazy(() => import('../../views/Compete'));
const Trophy = lazy(() => import('../../views/Trophy'));
const Upc = lazy(() => import('../../views/Upc'));
const Final = lazy(() => import('../../views/Final'));
// const IndoorOpen = lazy(() => import('../../views/IndoorOpen'));
// const MinHusbilOpen = lazy(() => import('../../views/MinHusbilOpen'));
const TrophyFootjoy = lazy(() => import('../../views/TrophyFootjoy'));
const Contests = lazy(() => import('../../views/Contests'));
const TrophyPartners = lazy(() => import('../../views/TrophyPartners'));
const UpcPartners = lazy(() => import('../../views/UpcPartners'));
const TrophyBroHof = lazy(() => import('../../views/TrophyFinal'));
const ContestOrderOfMerit = lazy(() => import('../../views/ContestOrderOfMerit'));
const SeasonOpening = lazy(() => import('../../views/SeasonOpening'));
const SASEuroBonus = lazy(() => import('../../views/SASEuroBonus'));
const Redirect = lazy(() => import('../../views/Redirect'));
const Quiz = lazy(() => import('../../views/Quiz'));
const QuizWhoSaidIt = lazy(() => import('../../views/QuizWhoSaidIt'));
const PublicDeals = lazy(() => import('../../views/PublicDeals/PublicDeals'));
const Deal = lazy(() => import('../../views/Deal'));
const Campaign = lazy(() => import('../../views/Campaign'));
const AdventCalendar = lazy(() => import('../../views/AdventCalendar'));
const App = lazy(() => import('../../views/App'));
const WebForm = lazy(() => import('../../views/WebForm'));
const FreeRound = lazy(() => import('../../views/FreeRound'));
const Referral = lazy(() => import('../../views/Referral'));
const CustomerClub = lazy(() => import('../../views/CustomerClub/CustomerClub'));
const Events = lazy(() => import('../../views/Events/Events'));
const OrderOfMerit = lazy(() => import('../../views/Events/OrderOfMerit'));
const Calendar = lazy(() => import('../../views/Events/Calendar'));
const Competitions = lazy(() => import('../../views/Events/Competitions'));
const CompetitionGolfamoreTrophy = lazy(() => import('../../views/Events/Competitions/CompetitionGolfamoreTrophy'));
const CompetitionUnderParChallenge = lazy(() => import('../../views/Events/Competitions/CompetitionUnderParChallenge'));
const CompetitionFootJoyMasters = lazy(() => import('../../views/Events/Competitions/CompetitionFootJoyMasters'));
// const CompetitionIndoorOpen = lazy(() => import('../../views/Events/Competitions/CompetitionIndoorOpen'));
const Tours = lazy(() => import('../../views/Events/Tours'));
const TourBroHof = lazy(() => import('../../views/Events/Tours/TourBroHof'));
const TourTheNational = lazy(() => import('../../views/Events/Tours/TourTheNational'));
const TourVallda = lazy(() => import('../../views/Events/Tours/TourVallda'));
const TourOsteraker = lazy(() => import('../../views/Events/Tours/TourOsteraker'));
const TourHalmstad = lazy(() => import('../../views/Events/Tours/TourHalmstad'));
const Extreme = lazy(() => import('../../views/Events/Extreme'));
const Academy = lazy(() => import('../../views/Academy/Academy'));
const KustomPayment = lazy(() => import('../../components/KustomPayment'));

const Bunkered = lazy(() => import('../../views/Bunkered'));
const DanskGolfShow = lazy(() => import('../../views/DanskGolfShow'));
const Leads = lazy(() => import('../../views/Leads'));

const OnTour = lazy(() => import('../../views/OnTour'));
const RegretOrder = lazy(() => import('../../views/RegretOrder'));
const ExtremeSignUp = lazy(() => import('../../views/ExtremeSignUp'));
const ScorecardSurvey = lazy(() => import('../../views/ScorecardSurvey'));

// Only germany
const AlexandraFonsterling = lazy(() => import('../../views/germany/AlexandraFonsterling'));
const AGB = lazy(() => import('../../views/germany/Agb'));
const Widerrufsbelehrung = lazy(() => import('../../views/germany/Widerrufsbelehrung'));
const Impressum = lazy(() => import('../../views/germany/Impressum'));
const Datenschutzerklarung = lazy(() => import('../../views/germany/Datenschutzerklarung'));

// Keep synced with ./paths.js since we need this on two places to prevent circular dependencies.
const routesSetup = [
  {
    // name: 'Index',
    component: Index,
    paths: {
      sv: '',
      dk: '',
      no: '',
      en: '',
      de: '',
      nl: ''
    }
  },
  {
    // name: 'Activate',
    component: Activate,
    paths: {
      sv: 'aktivera-kort',
      dk: 'aktiver-kort',
      no: 'aktivere-kort',
      en: 'activate-card',
      de: 'karte-aktivieren',
      nl: 'kaart-activeren'
    }
  },
  {
    // name: 'Activate',
    component: ActivateDone,
    paths: {
      sv: 'aktivera-kort/klart',
      dk: 'aktiver-kort/færdig',
      no: 'aktivere-kort/ferdig',
      en: 'activate-card/done',
      de: 'karte-aktivieren/abgeschlossen',
      nl: 'kaart-activeren/gedaan'
    }
  },
  {
    // name: 'Activate',
    component: ActivateAdidas,
    paths: {
      sv: 'aktivera-kort/adidas',
      dk: 'aktiver-kort/adidas',
      no: 'aktivere-kort/adidas',
      en: 'activate-card/adidas',
      de: 'activate-card/adidas'
    }
  },
  // {
  //   // name: 'Activate',
  //   component: ActivateAdidas,
  //   paths: {
  //     sv: 'aktivera-kort/adidas',
  //     dk: 'aktiver-kort/adidas',
  //     no: 'aktivere-kort/adidas',
  //     en: 'activate-card/adidas',
  //     de: 'activate-card/adidas'
  //   }
  // },
  {
    // name: 'ActivatePlus',
    component: ActivatePlus,
    paths: {
      sv: 'aktivera-kort/plus',
      dk: 'aktiver-kort/plus',
      no: 'aktivere-kort/plus',
      en: 'activate-card/plus',
      de: 'activate-card/plus',
      nl: 'kaart-activeren/plus'
    }
  },
  {
    // name: 'Webshop',
    component: Webshop,
    paths: {
      sv: 'webshop',
      dk: 'webshop',
      no: 'webshop',
      en: 'webshop',
      de: 'webshop',
      nl: 'webshop'
    }
  },
  {
    component: Map,
    paths: {
      sv: 'karta',
      dk: 'kort',
      no: 'kart',
      en: 'map',
      de: 'karte',
      nl: 'kaart'
    }
  },
  {
    // name: 'GolfCourses',
    component: GolfCourses,
    paths: {
      sv: 'golfbanor',
      dk: 'golfbaner',
      no: 'golfbaner',
      en: 'golf-courses',
      de: 'golf-courses',
      nl: 'golfbanen'
    }
  },
  {
    component: CountryDistrict,
    paths: {
      sv: 'golfbanor/:country',
      dk: 'golfbaner/:country',
      no: 'golfbaner/:country',
      en: 'golf-courses/:country',
      de: 'golf-courses/:country',
      nl: 'golfbanen/:country'
    }
  },
  {
    component: CountryDistrict,
    paths: {
      sv: 'golfbanor/:country/:district',
      dk: 'golfbaner/:country/:district',
      no: 'golfbaner/:country/:district',
      en: 'golf-courses/:country/:district',
      de: 'golf-courses/:country/:district',
      nl: 'golfbanen/:country/:district'
    }
  },
  {
    // name: 'GolfCourse',
    component: GolfCourse,
    paths: {
      sv: 'golfbanor/:country/:district/:course',
      dk: 'golfbaner/:country/:district/:course',
      no: 'golfbaner/:country/:district/:course',
      en: 'golf-courses/:country/:district/:course',
      de: 'golf-courses/:country/:district/:course',
      nl: 'golfbanen/:country/:district/:course'
    }
  },
  {
    // name: 'Trophy',
    component: Compete,
    paths: {
      sv: 'tavla',
      dk: 'konkurrence',
      no: 'konkurranse',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    // name: 'Trophy',
    component: Trophy,
    paths: {
      sv: 'tavla/trophy',
      dk: 'konkurrence/trophy',
      no: 'konkurranse/trophy',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Final,
    paths: {
      sv: 'tavla/final',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Upc,
    paths: {
      sv: 'tavla/upc/:club?',
      dk: 'konkurrence/upc/:club',
      no: 'konkurranse/upc/:club',
      en: null,
      de: null,
      nl: null
    }
  },
  // {
  //   component: IndoorOpen,
  //   paths: {
  //     sv: 'tavla/indoor-open',
  //     dk: null,
  //     no: null,
  //     en: null,
  //     de: null,
  //   }
  // },
  // {
  //   component: MinHusbilOpen,
  //   paths: {
  //     sv: 'tavla/minhusbil-open',
  //     dk: null,
  //     no: null,
  //     en: null,
  //     de: null,
  //   }
  // },
  {
    component: TrophyFootjoy,
    paths: {
      sv: 'tavla/trophy/footjoy',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Contests,
    paths: {
      sv: 'tavla/program',
      dk: 'konkurrence/program',
      no: 'konkurranse/skjema',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    // name: 'TrophyPartners',
    component: TrophyPartners,
    paths: {
      sv: 'tavla/trophy/partners',
      dk: 'konkurrence/trophy/partnere',
      no: 'konkurranse/trophy/partners',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: UpcPartners,
    paths: {
      sv: 'tavla/upc/partners',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    // name: 'TrophyBroHof',
    component: TrophyBroHof,
    paths: {
      sv: 'tavla/trophy/final',
      dk: 'konkurrence/trophy/finale',
      no: 'konkurranse/trophy/finale',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: ContestOrderOfMerit,
    paths: {
      sv: 'tavla/order-of-merit',
      dk: 'konkurrence/order-of-merit',
      no: 'konkurranse/order-of-merit',
      en: 'contest/order-of-merit',
      de: null,
      nl: null
    }
  },
  {
    // name: 'Plus',
    component: Plus,
    paths: {
      sv: 'plus',
      dk: 'plus',
      no: 'plus',
      en: 'plus',
      de: 'plus',
      nl: 'plus'
    }
  },
  {
    // name: 'Why buy the card',
    component: WhyBuyCard,
    paths: {
      sv: 'varfor-kopa-kortet',
      dk: 'hvorfor-kobe-kortet',
      no: 'plhvorfor-kjope-kortetus',
      en: 'why-buy-the-card',
      de: 'warum-die-karte-kaufen',
      nl: 'waarom-de-kaart-kopen'
    }
  },
  {
    // name: 'Login',
    component: Login,
    paths: {
      sv: 'min-golf/logga-in',
      dk: 'min-golf/log-ind',
      no: 'min-golf/logg-in',
      en: 'my-golf/login',
      de: 'my-golf/login',
      nl: 'my-golf/login'
    }
  },
  {
    // name: 'Account',
    component: Account,
    paths: {
      sv: 'min-golf/:view',
      dk: 'min-golf/:view',
      no: 'min-golf/:view',
      en: 'my-golf/:view',
      de: 'my-golf/:view',
      nl: 'my-golf/:view'
    },
    privateRoute: true
  },
  {
    // name: 'Account',
    component: Account,
    paths: {
      sv: 'min-golf',
      dk: 'min-golf',
      no: 'min-golf',
      en: 'my-golf',
      de: 'my-golf',
      nl: 'my-golf'
    },
    privateRoute: true
  },
  {
    // name: 'News',
    component: News,
    paths: {
      sv: 'nyheter',
      dk: 'nyheder',
      no: 'nyheter',
      en: 'news',
      de: 'neuigkeiten',
      nl: 'nieuws'
    }
  },
  {
    // name: 'News',
    component: NewsPost,
    paths: {
      sv: 'nyheter/:date/:link',
      dk: 'nyheder/:date/:link',
      no: 'nyheter/:date/:link',
      en: 'news/:date/:link',
      de: 'neuigkeiten/:date/:link',
      nl: 'nieuws/:date/:link'
    }
  },
  {
    // name: 'Faq',
    component: Faq,
    paths: {
      sv: 'faq',
      dk: 'faq',
      no: 'faq',
      en: 'faq',
      de: 'faq',
      nl: 'faq'
    }
  },
  {
    // name: 'About',
    component: About,
    paths: {
      sv: 'om-oss',
      dk: 'om-os',
      no: 'om-oss',
      en: 'about',
      de: 'about',
      nl: 'over-ons'
    }
  },
  {
    // name: 'Retailers',
    component: Retailers,
    paths: {
      sv: 'aterforsaljare',
      dk: 'forhandler',
      no: 'forhandler',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    // name: 'Contact',
    component: Contact,
    paths: {
      sv: 'kontakt',
      dk: 'kontakt',
      no: 'kontakt',
      en: 'contact',
      de: 'contact',
      nl: 'contact'
    }
  },
  {
    // name: 'Press',
    component: Press,
    paths: {
      sv: 'press',
      dk: 'press',
      no: 'press',
      en: 'press',
      de: 'press',
      nl: 'pers'
    }
  },
  {
    // name: 'Terms',
    component: Terms,
    paths: {
      sv: 'kopvillkor',
      dk: 'vilkar',
      no: 'vilkar',
      en: 'terms',
      de: 'terms',
      nl: 'voorwaarden'
    }
  },
  {
    // name: 'Privacy',
    component: Privacy,
    paths: {
      sv: 'integritetspolicy',
      dk: 'privatlivspolitik',
      no: 'personvern',
      en: 'privacy-policy',
      de: 'privacy-policy',
      nl: 'privacybeleid'
    }
  },
  {
    // name: 'Cookies',
    component: Cookies,
    paths: {
      sv: 'cookies',
      dk: 'cookies',
      no: 'cookies',
      en: 'cookies',
      de: 'cookies',
      nl: 'cookies'
    }
  },
  {
    // name: 'Recommend',
    component: Recommend,
    paths: {
      sv: 'rekommendera',
      dk: 'anbefale',
      no: 'anbefale',
      en: 'recommend',
      de: null,
      nl: 'aanbevelen'
    }
  },
  {
    // name: 'GolfClub',
    component: GolfClub,
    paths: {
      sv: 'golfklubb',
      dk: 'golfklub',
      no: 'golfklubb',
      en: 'golf-club',
      de: 'golf-club',
      nl: 'golfclub'
    }
  },
  {
    // name: 'GolfClub',
    component: GolfClubCalculator,
    paths: {
      sv: 'golfklubb/kalkylator',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    // name: 'Survey',
    component: Survey,
    paths: {
      sv: 'undersokning',
      dk: 'undersogelse',
      no: 'undersokelse',
      en: 'survey',
      de: 'survey',
      nl: 'enquete'
    }
  },
  {
    // name: 'How it works',
    component: HowItWorks,
    paths: {
      sv: 'sa-fungerar-det',
      dk: 'sådan-fungerer-det',
      no: 'slik-det-fungerer',
      en: 'how-it-works',
      de: 'so-funktioniert-es',
      nl: 'hoe-het-werkt'
    }
  },
  {
    component: Campaign,
    paths: {
      sv: 'kampanj',
      dk: 'kampagne',
      no: 'kampanje',
      en: 'campaign',
      de: 'kampagne',
      nl: 'campagne'
    }
  },
  {
    component: SeasonOpening,
    paths: {
      sv: 'golfsäsongen-2026',
      dk: 'golfsæson-2026',
      no: 'golfsesong-2026',
      en: 'golf-season-2026',
      de: 'golf-saison-2026',
      nl: 'golf-seizoen-2026'
    }
  },
  {
    component: SASEuroBonus,
    paths: {
      sv: 'partners/sas-eurobonus',
      dk: 'partners/sas-eurobonus',
      no: 'partners/sas-eurobonus',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: CustomerClub,
    paths: {
      sv: 'kund-klubb',
      dk: 'kunde-klub',
      no: 'kunde-klubb',
      en: 'customer-club',
      de: 'kunden-club',
      nl: 'klantenclub'
    }
  },
  {
    component: Extreme,
    paths: {
      sv: 'events/extreme',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Quiz,
    paths: {
      sv: 'quiz',
      dk: 'quiz',
      no: null,
      en: null,
      de: 'quiz',
      nl: 'quiz'
    }
  },
  {
    component: QuizWhoSaidIt,
    paths: {
      sv: null,
      dk: null,
      no: null,
      en: 'quiz-who-said-it',
      de: null,
      nl: null
    }
  },
  {
    component: PublicDeals,
    paths: {
      sv: 'deals',
      dk: 'deals',
      no: 'deals',
      en: null,
      de: 'angebote',
      nl: 'aanbiedingen'
    }
  },
  {
    component: Deal,
    paths: {
      sv: 'deals/:name',
      dk: 'deals/:name',
      no: 'deals/:name',
      en: null,
      de: 'angebote/:name',
      nl: 'aanbiedingen/:name'
    }
  },
  {
    component: AdventCalendar,
    paths: {
      sv: 'adventskalender',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: App,
    paths: {
      sv: 'app',
      dk: 'app',
      no: 'app',
      en: 'app',
      de: 'app',
      nl: 'app'
    }
  },
  {
    component: WebForm,
    paths: {
      sv: 'web-form/:id/:golfclub/:hash',
      dk: '',
      no: '',
      en: '',
      de: '',
      nl: ''
    }
  },
  {
    component: FreeRound,
    paths: {
      sv: 'bjudrundan',
      dk: '',
      no: '',
      en: '',
      de: 'proberunde',
      nl: ''
    }
  },
  {
    component: Referral,
    paths: {
      sv: 'referral',
      dk: '',
      no: '',
      en: '',
      de: '',
      nl: ''
    }
  },
  {
    component: AGB,
    paths: {
      sv: null,
      dk: null,
      no: null,
      en: null,
      de: 'agb',
      nl: null
    }
  },
  {
    component: Widerrufsbelehrung,
    paths: {
      sv: null,
      dk: null,
      no: null,
      en: null,
      de: 'widerrufsbelehrung',
      nl: null
    }
  },
  {
    component: Impressum,
    paths: {
      sv: null,
      dk: null,
      no: null,
      en: null,
      de: 'impressum',
      nl: null
    }
  },
  {
    component: Datenschutzerklarung,
    paths: {
      sv: null,
      dk: null,
      no: null,
      en: null,
      de: 'datenschutzerklarung',
      nl: null
    }
  },
  // new Golfamore Events
  {
    component: Events,
    paths: {
      sv: 'events',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Competitions,
    paths: {
      sv: 'events/tävlingar',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: CompetitionGolfamoreTrophy,
    paths: {
      sv: 'events/golfamore-trophy',
      dk: null,
      no: 'events/golfamore-trophy',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: CompetitionUnderParChallenge,
    paths: {
      sv: 'events/under-par-challenge',
      dk: 'events/under-par-challenge',
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: CompetitionFootJoyMasters,
    paths: {
      sv: 'events/footjoy-masters',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  // {
  //   component: CompetitionIndoorOpen,
  //   paths: {
  //     sv: 'events/indoor-open',
  //     dk: null,
  //     no: null,
  //     en: null,
  //     de: null,
  //   }
  // },
  {
    component: Calendar,
    paths: {
      sv: 'events/tavlingskalendern',
      dk: 'events/turneringskalender',
      no: 'events/tuneringskalender',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: OrderOfMerit,
    paths: {
      sv: 'events/order-of-merit',
      dk: 'events/order-of-merit',
      no: 'events/order-of-merit',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Tours,
    paths: {
      sv: 'events/on-tour',
      dk: 'events/on-tour',
      no: null,
      en: 'events/on-tour',
      de: 'events/on-tour',
      nl: null
    }
  },
  {
    component: TourBroHof,
    paths: {
      // sv: 'events/on-tour-bro-hof',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: TourTheNational,
    paths: {
      // sv: 'events/on-tour-the-national',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: TourVallda,
    paths: {
      // sv: 'events/on-tour-vallda',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: TourOsteraker,
    paths: {
      // sv: 'events/on-tour-osteraker',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: TourHalmstad,
    paths: {
      // sv: 'events/on-tour-halmstad',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Bunkered,
    paths: {
      // sv: 'events/on-tour-halmstad',
      sv: null,
      dk: null,
      no: null,
      en: 'bunkered',
      de: null,
      nl: null
    }
  },
  {
    component: DanskGolfShow,
    paths: {
      sv: null,
      dk: 'danskgolfshow',
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    component: Index,
    paths: {
      sv: 'i/:influencer',
      dk: 'i/:influencer',
      no: 'i/:influencer',
      en: 'i/:influencer',
      de: 'i/:influencer',
      nl: 'i/:influencer'
    }
  },
  {
    component: OnTour,
    paths: {
      sv: 'ontour',
      dk: 'ontour',
      no: null,
      en: 'ontour',
      de: 'ontour',
      nl: null
    }
  },
  {
    component: OnTour,
    paths: {
      sv: 'ontour',
      dk: 'ontour',
      no: null,
      en: 'ontour',
      de: 'ontour',
      nl: null
    }
  },
  {
    component: ExtremeSignUp,
    paths: {
      sv: 'extreme'
    }
  },
  {
    // name: 'Academy',
    component: Academy,
    paths: {
      sv: 'akademin',
      dk: 'akademi',
      no: 'akademi',
      en: 'academy',
      de: 'akademie',
      nl: 'academie'
    }
  },
  {
    component: KustomPayment,
    paths: {
      sv: 'betalning',
      dk: 'betaling',
      no: 'betaling',
      en: 'payment',
      de: 'zahlung',
      nl: 'betaling'
    }
  },
  {
    component: KustomReceipt,
    paths: {
      sv: 'betalning/kvitto',
      dk: 'betaling/kvittering',
      no: 'betaling/kvittering',
      en: 'payment/receipt',
      de: 'zahlung/quittung',
      nl: 'betaling/ontvangstbewijs'
    }
  },
  {
    component: ScorecardSurvey,
    paths: {
      sv: 'scorecard-survey',
      dk: null,
      no: null,
      en: 'scorecard-survey',
      de: null,
      nl: null
    }
  },
  {
    component: AlexandraFonsterling,
    paths: {
      sv: 'alexandra-fonsterling',
      dk: 'alexandra-fonsterling',
      no: 'alexandra-fonsterling',
      en: 'alexandra-fonsterling',
      de: 'alexandra-fonsterling',
      nl: 'alexandra-fonsterling'
    }
  },
  {
    // name: 'RegretOrder',
    component: RegretOrder,
    paths: {
      sv: 'angerratt',
      dk: 'fortrydelsesret',
      no: 'angrerett',
      en: 'right-of-withdrawal',
      de: 'widerruf',
      nl: 'herroepingsrecht'
    }
  },
  {
    // name: 'Redirect',
    component: Redirect,
    paths: {
      sv: 'r',
      dk: 'r',
      no: 'r',
      en: 'r',
      de: 'r',
      nl: 'r'
    }
  }
];

const languageCode = detectLanguage();

const routes = routesSetup.map((r) => ({
  path: `/${languageCode}/${r.paths[languageCode]}`,
  component: r.component,
  privateRoute: r.privateRoute
}));

routes.push({ path: '/r', name: 'Redirect', component: Redirect });

export default routes;
